module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content stories"
  }, [_c('h2', {
    staticClass: "crossline-title text-center"
  }, [_vm._v("Featured Stories")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('share-story', {
    attrs: {
      "hr": "above"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', [_vm._v("Submit your story to be featured here!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5414c4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stories.vue
// module id = lWcK
// module chunks = 1